import React, { useState, useEffect } from 'react';
import { Button, Modal, Col, Stack, Table, Row } from 'react-bootstrap';

function PalatumButtonModal({
    getDataDentalPalatum,
    cleanedTooth,
    toothPalatum,
    setToothPalatum,
    selectedTeeth,
    activePalatumSelections,
    setActivePalatumSelections,
    tempPalatumSelections,
    setTempPalatumSelections,
    activeMode,
    setActiveMode,
    onPalatumSelected,
    onModalOpen,
    setOpenModalType,
}) {
    const [showModal, setShowModal] = useState(false);
    const sourceData = getDataDentalPalatum || [];
    const grayColor = '#6c757d';

    const applyToSingleTooth = () => {
        if (tempPalatumSelections.length === 0) return;

        const selected = tempPalatumSelections[0];
        const id = selected.id;
        const label = selected.label;

        // Simpan ID ke state
        setActivePalatumSelections([id]);
        setToothPalatum(prev => ({
            ...prev,
            [cleanedTooth]: [id],
        }));

        if (!selectedTeeth.includes(cleanedTooth)) {
            selectedTeeth.push(cleanedTooth);
        }

        // Kirim label dan description ke parent
        if (typeof onPalatumSelected === 'function') {
            const matched = sourceData.find(item => item.id === id);
            const displayLabel = matched?.display_name || label;
            const description = matched?.description || "";
            onPalatumSelected([{
                id,
                display_name: displayLabel,
                description,
            }]);
        }

        setShowModal(false);
    };

    useEffect(() => {
        if (showModal && typeof onModalOpen === 'function') {
            onModalOpen();
        }
    }, [showModal]);

    useEffect(() => {
        if (showModal) {
            const currentIds = toothPalatum[cleanedTooth] || [];
            const updated = sourceData
                .filter(item => currentIds.includes(item.id))
                .map(item => ({ id: item.id, label: item.display_name }));
            setTempPalatumSelections(updated);
        }
    }, [showModal, cleanedTooth, toothPalatum, sourceData]);

    const handleSelect = (item) => {
        const isSelected = tempPalatumSelections.some(sel => sel.id === item.id);
        setTempPalatumSelections(isSelected ? [] : [{ id: item.id, label: item.display_name }]);
    };

    return (
        <>
            <Col>
                <Stack>
                    {(toothPalatum?.[cleanedTooth]?.length > 0) ? (
                        <Table
                            bordered
                            size="sm"
                            className="mt-2 mb-0"
                            style={{
                                cursor: 'pointer',
                                fontSize: '0.8rem',
                                width: 'auto',
                                maxWidth: '250px',
                                borderColor: '#dee2e6'
                            }}
                            onClick={() => setShowModal(true)}
                        >
                            <thead className="table-light">
                                <tr>
                                    <th
                                        style={{
                                            padding: '4px 8px',
                                            backgroundColor: '#dee2e6',
                                            fontWeight: '600',
                                            fontSize: '0.75rem',
                                            textAlign: 'left',
                                            color: '#343a40'
                                        }}
                                    >
                                        Palatum
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {(toothPalatum?.[cleanedTooth] || []).map((id, idx) => {
                                    const item = sourceData.find(i => i.id === id);
                                    return (
                                        <tr key={id || idx}>
                                            <td style={{ padding: '4px 8px' }}>
                                                &bull; {item?.display_name || '-'}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    ) : (
                        <Button
                            size="sm"
                            onClick={() => {
                                setShowModal(true)
                                setOpenModalType('palatum')
                            }}
                            style={{
                                width: '100%',
                                whiteSpace: 'normal',
                                wordWrap: 'break-word',
                                textAlign: 'center',
                                fontSize: '0.75rem',
                                lineHeight: '1rem',
                                padding: '4px',
                                backgroundColor: 'transparent',
                                color: '#343a40',
                                borderColor: '#ced4da',
                                borderWidth: '1px',
                                borderStyle: 'solid',
                            }}
                        >
                            Palatum
                        </Button>
                    )}
                </Stack>
            </Col>

            <Modal size="lg" show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <strong>Pilih Palatum</strong>
                </Modal.Header>
                <Modal.Body
                    className="text-center"
                    style={{
                        border: `2px solid ${grayColor}`,
                        color: '#000',
                        borderRadius: '6px',
                        padding: '20px'
                    }}
                >
                    <Row className="justify-content-center">
                        {sourceData.map(item => {
                            const isChecked = tempPalatumSelections.some(sel => sel.id === item.id);
                            return (
                                <Col key={item.id} md={4} className="mb-2 d-flex justify-content-center">
                                    <Button
                                        size="sm"
                                        onClick={() => handleSelect(item)}
                                        className="w-100"
                                        style={{
                                            backgroundColor: isChecked ? '#dee2e6' : 'transparent',
                                            color: '#000000',
                                            borderColor: grayColor,
                                            borderWidth: '1px',
                                            borderStyle: 'solid',
                                            borderRadius: '6px',
                                            padding: '6px 12px',
                                            fontWeight: 500
                                        }}
                                    >
                                        {item.display_name}
                                    </Button>
                                </Col>
                            );
                        })}
                    </Row>

                    <div className="d-flex justify-content-end mt-3">
                        <Button
                            size="sm"
                            onClick={applyToSingleTooth}
                            style={{
                                backgroundColor: grayColor,
                                borderColor: grayColor,
                                color: '#fff'
                            }}
                        >
                            Pilih
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default PalatumButtonModal;
